import React, { useState } from 'react'
import PropTypes from 'prop-types'
import styles from './style.module.scss'

function ConditionalSliderVideosHeader({ headerTitle, data = [], children }) {
  const [selectedData, setSelectedData] = useState(data[0] || {})
  const [activeKey, setActiveKey] = useState(
    data[0]?.title?.toLowerCase() || 'all'
  )

  const handleSelect = (item) => {
    setSelectedData(item)
    setActiveKey(item?.title?.toLowerCase())
  }

  return (
    <div>
      <div className={`${styles.headerWrapper}`}>
      <div className={`${styles.headerContainer}`}>
        <h4 className={`${styles.h4MarginBtm} h4`}>{headerTitle}</h4>
        <div className={`${styles.scorecardNav} overflow-scroll`}>
          {data.map((item, idx) => (
            <button
              key={`header-button-${idx}`}
              className={`${styles.headerButton} ${
                activeKey === item?.title?.toLowerCase() ? styles.active : ''
              }`}
              onClick={() => handleSelect(item)}
            >
              {item?.title}
            </button>
          ))}
        </div>
      </div>
      </div>

      {children &&
        React.isValidElement(children) &&
        React.cloneElement(children, { selectedData })}
    </div>
  )
}

ConditionalSliderVideosHeader.propTypes = {
  headerTitle: PropTypes.string,
  data: PropTypes.array,
  children: PropTypes.element
}

export default ConditionalSliderVideosHeader
